import NavBar from "./components/Navbar/NavBar";

function App() {
  return (
    <>
      <NavBar />
    </>
  );
}

export default App;
